import { AxiosResponse } from 'axios';
import client from './client';
import { BASE_URL } from 'src/config/api';

interface PointSetting {
    isPointUsableForSpecialPrice?: boolean;
    isLiveRewardPointEnabled?: boolean;
    liveRewardPointAmount?: number;
}

export function issuePoint(body: {
    exceilFile: File;
    pointType: '1' | '2';
    point: number;
    memo: string;
}): Promise<AxiosResponse<any>> {
    return client.post(`${BASE_URL}/v1/admin/point/issued/excel`, body);
}

export function getPointSetting(lsBroadcastId: number): Promise<AxiosResponse<PointSetting>> {
    return client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/point`);
}

export function putPointSetting(lsBroadcastId: number, body: PointSetting): Promise<AxiosResponse<PointSetting>> {
    return client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/point`, body);
}
